module.exports = __webpack_public_path__ + "static/media/mashroom.b006ea3e.svg";